import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MessageObfuscationType } from '@models/user';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AtlasToastService } from '@services/atlas-toast.service';
import { UserService } from '@services/user.service';
import { CheckboxComponent } from '@ui/components/checkbox/checkbox.component';
import { LocalStorageService } from 'ngx-webstorage';
import { LoginService } from 'src/app/core/login/login.service';

@Component({
  selector: 'wsb-privacy-setting-modal',
  templateUrl: './privacy-setting-modal.component.html',
  styleUrls: ['./privacy-setting-modal.component.scss'],
  standalone: false
})
export class PrivacySettingModalComponent implements OnInit {
  @ViewChild('dontShowAgainCheckbox') dontShowAgainCheckbox: CheckboxComponent;
  @ViewChild('messageObfuscationCheck') messageObfuscationCheck: CheckboxComponent;
  @Input() title = '';
  @Input() messageObfuscationType;
  checkPassword: UntypedFormControl = new UntypedFormControl('', []);
  dontShowAgainCheck: UntypedFormControl = new UntypedFormControl(false, []);

  messageObfuscationTypeCheck = false;
  messageObfuscationTypeControl = false;
  // dontShowAgainCheck = false;
  constructor(
    public activeModal: NgbActiveModal,
    private loginService: LoginService,
    private atlasToast: AtlasToastService,
    private userService: UserService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.checkMessageObfuscationType(this.messageObfuscationType);
    this.checkPassword.disable();
  }

  messageObfuscationTypeChange() {
    if (this.checkObfuscationChange()) {
      return this.checkPassword.enable();
    }
    return this.checkPassword.disable();
  }

  checkPwd() {
    this.loginService.checkPassword(this.checkPassword.value).subscribe(
      success => {
        this.submitMessageObfuscationType();
        this.activeModal.close(true);
      },
      error => {
        this.atlasToast.error('common_error', null);
      }
    );
  }

  submitMessageObfuscationType() {
    this.userService.setMessageObfuscationType(MessageObfuscationType.NO_OBFUSCATION).subscribe(() => {
      this.localStorageService.store('hide-privacy-setting-popup', true);
    });
  }

  checkObfuscationChange() {
    if (this.messageObfuscationTypeCheck !== this.messageObfuscationTypeControl) {
      return true;
    }
    return false;
  }

  checkMessageObfuscationType(messageObfuscationType) {
    if (!messageObfuscationType) {
      return;
    }
    if (messageObfuscationType === MessageObfuscationType.OBFUSCATE_MESSAGE_BODY) {
      this.messageObfuscationTypeCheck = false;
      this.messageObfuscationTypeControl = false;
      return;
    }
    this.messageObfuscationTypeCheck = true;
    this.messageObfuscationTypeControl = true;
    return;
  }
}
